<template>
  <div class="container-custom" v-if="teamDetail">
    <!-- breadscrumbs -->
    <div class="breadscrumbs">
      <router-link to="/carrer-page" class="breadscrumbs-item"
        >Carrer</router-link
      >
      <v-icon>chevron_right</v-icon>
      <router-link to="/carrer-page/edit" class="breadscrumbs-item"
        >Edit</router-link
      >
      <v-icon>chevron_right</v-icon>
      <a class="breadscrumbs-item active">Department Detail Edit</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 Career Page</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!-- block -->
    <div class="block mb-5">
      <!-- Department Name -->
      <label class="form-item pt-5 d-flex">
        <h4 class="w-240px mr-5">Department Name</h4>
        <div class="my-n2 flex-grow-1">
          <v-text-field
            v-model="teamDetail.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Team introduction -->
      <label class="form-item pt-5 d-flex">
        <h4 class="w-240px mr-5">Team introduction</h4>
        <div class="fmy-n2 flex-grow-1">
          <v-text-field
            v-model="teamDetail.introduction"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>

      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Team visual</h4>
          <div class="h5 ink-02-medium--text">
            呈現於Career Page <br />
            建議尺寸：930px * 550px <br />
            檔案大小限制：≤20MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="teamDetail.visual"
            dir="career"></ImgUploader>
        </div>
      </div>

      <!-- Introduction Page Title -->
      <label class="form-item pt-5 d-flex">
        <h4 class="w-240px mr-5">Introduction Page Title</h4>
        <div class="my-n2 flex-grow-1">
          <v-text-field
            v-model="teamDetail.introduction_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>

      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Introduction Page Banner</h4>
          <div class="h5 ink-02-medium--text">
            呈現於Introduction Page置頂區 <br />
            建議尺寸：999px * 999px <br />c
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="teamDetail.introduction_banner"
            dir="career"></ImgUploader>
        </div>
      </div>
    </div>

    <div class="page-divider mb-5"></div>

    <!-- content -->
    <div class="d-flex">
      <!-- content head -->
      <div class="w-300px mr-5">
        <h3 class="mb-10px">Content</h3>
        <div class="h4">
          至少需填寫一組 <br />
          於前台左圖右字、右圖左字交錯排版
        </div>
      </div>
      <div class="flex-grow-1">
        <!-- content body -->
        <div class="block mb-5" v-for="(item, i) in teamDetail.content" :key="i">
          <!-- content -->
          <div
            class="form-item py-5 d-flex align-center justify-lg-space-between"
          >
            <h4>Content</h4>
            <button
              v-if="i > 0"
              class="btn btn-danger square w-32px h-32px"
              @click="deleteItem(item)"
            >
              <v-icon color="white">delete</v-icon>
            </button>
          </div>
          <!-- Title -->
          <label class="form-item d-flex pt-5">
            <h4 class="w-160px mr-5">Title</h4>
            <div class="my-n2 flex-grow-1">
              <v-text-field
                v-model="item.title"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
          <!-- Description -->
          <label class="form-item d-flex pt-5">
            <h4 class="w-160px mr-5">Description</h4>
            <div class="my-n2 flex-grow-1">
              <v-textarea
                v-model="item.description"
                outlined
                dense
              ></v-textarea>
            </div>
          </label>
          <!-- img uploader -->
          <div class="form-item d-flex px-5 py-5">
            <div class="w-180px">
              <h4 class="mb-10px">Visual</h4>
              <div class="h5 ink-02-medium--text">
                建議尺寸：999px * 999px <br />
                檔案大小限制：&lt; 1 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <ImgUploader
                :imageUrl.sync="item.visual"
                dir="career"></ImgUploader>
            </div>
          </div>
        </div>
        <!-- add Content Section -->
        <div class="mt-5 mb-9">
          <button class="btn btn-outlined w-100 justify-start" @click="addItem">
            <v-icon class="primary--text mr-2">add_circle</v-icon>
            <span>添加Content Section</span>
          </button>
        </div>
        <div class="page-actions">
          <v-spacer></v-spacer>
          <button class="btn mr-5" @click="cancelHandler">
            <span>取消</span>
          </button>
          <button class="btn btn-primary" @click="saveHandler">
            <span>儲存</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  components: {
    ImgUploader,
  },
  computed: {
    ...mapState('career', ['career', 'teamDetail']),
  },
  methods: {
    ...mapActions('career', ['clear', 'setTeamDetail', 'saveTeam']),
    addItem() {
      const template = {
        title: '',
        description: '',
        visual: '',
      };
      this.teamDetail.content.push(template);
    },
    deleteItem(item) {
      const index = this.teamDetail.content.map((i) => i.id).indexOf(item.id);
      this.teamDetail.content.splice(index, 1);
    },
    cancelHandler() {
      this.$router.go(-1);
    },
    async saveHandler() {
      if (this.career === null) {
        await this.saveTeam(this.teamDetail).then(() => {
          this.clear();
        });
      } else {
        this.setTeamDetail(this.teamDetail);
      }
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
